import * as React from 'react';

// tslint:disable:max-line-length
export const ArrowRigthIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="8" height="12" viewBox="0 0 8 12">
    <path
      fill="#FFF"
      fillRule="evenodd"
      d="M1.195 1.954L5.24 6l-4.046 4.047a1.144 1.144 0 0 0 1.619 1.617L7.669 6.81a1.144 1.144 0 0 0 0-1.619L2.814.335a1.146 1.146 0 0 0-1.62 1.619z"
    />
  </svg>
);
